import { useState } from 'react';
import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formMsg, setFormMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const phoneAlt = (formData.get('phone_alt') as string || '').trim();
    if (phoneAlt) {
      setFormStatus('success');
      setFormMsg('留言已提交，我们会尽快回复！');
      form.reset();
      return;
    }

    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'phone_alt') {
          params.append(key, value as string);
        }
      });

      const response = await fetch('https://readdy.ai/api/form/d9le9t8bdkpk99j7fvcg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: any = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormMsg('留言已提交，我们会尽快回复！');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
        setFormStatus('error');
        setFormMsg(serverMsg);
      }
    } catch {
      setFormStatus('error');
      setFormMsg('网络异常，请稍后重试');
    }
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">联系我们</h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-10">
          <div className="flex-1">
            <p className="text-sm text-foreground-600 leading-relaxed mb-8">{contactData.desc}</p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              {contactData.methods.map((method) => (
                <div
                  key={method.label}
                  className="bg-background-50 rounded-xl p-5 border border-background-200/60 text-center hover:border-primary-200/60 transition-colors duration-200 cursor-pointer"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mx-auto mb-3">
                    <i className={`${method.icon} text-xl`}></i>
                  </div>
                  <div className="text-xs text-foreground-500 mb-1">{method.label}</div>
                  <div className="text-sm font-medium text-foreground-900 break-all">{method.value}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-[380px] shrink-0">
            <div className="bg-background-50 rounded-xl p-6 border border-background-200/60">
              <h3 className="font-heading text-base text-foreground-900 mb-4">快速留言</h3>
              <form
                className="space-y-3"
                onSubmit={handleSubmit}
                data-readdy-form=""
              >
                <input
                  type="text"
                  name="name"
                  placeholder="你的昵称"
                  className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/60 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="你的邮箱"
                  className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/60 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                />
                <textarea
                  name="message"
                  placeholder="你想说的话..."
                  rows={3}
                  maxLength={500}
                  className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/60 rounded-lg text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                ></textarea>
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="form-website-alt"
                />
                <button
                  type="submit"
                  className="w-full py-2.5 bg-primary-500 text-white rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  发送留言
                </button>
                {formStatus !== 'idle' && (
                  <p className={`text-xs ${formStatus === 'success' ? 'text-primary-600' : 'text-accent-600'}`}>
                    {formMsg}
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}